export default {
  country: 'Land',
  language: 'Sprog',
  currency: 'Valuta',
}
